import axios from "axios";
import { registerAuthInterceptor } from "src/utils/authInterceptor";
import { enforceActiveWalletSession } from "src/utils";

let removeWalletSessionLivenessMonitor = null;

export const unregisterWalletSessionLivenessMonitor = () => {
  removeWalletSessionLivenessMonitor?.();
  removeWalletSessionLivenessMonitor = null;
};

export const registerWalletSessionLivenessMonitor = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }
  unregisterWalletSessionLivenessMonitor();

  let inFlight = null;
  const checkWalletSession = () => {
    if (document.hidden || inFlight) {
      return inFlight;
    }
    inFlight = enforceActiveWalletSession().finally(() => {
      inFlight = null;
    });
    return inFlight;
  };
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      checkWalletSession();
    }
  };
  window.addEventListener("focus", checkWalletSession);
  window.addEventListener("pageshow", checkWalletSession);
  document.addEventListener("visibilitychange", handleVisibilityChange);

  removeWalletSessionLivenessMonitor = () => {
    window.removeEventListener("focus", checkWalletSession);
    window.removeEventListener("pageshow", checkWalletSession);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
};

export default () => {
  axios.defaults.withCredentials = true;
  registerAuthInterceptor();
  registerWalletSessionLivenessMonitor();
};
